import { createStorageBase } from './createStorageBase';
export const coreSessionStorage = createStorageBase('session');
